import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowState } from '@plys/src/application/states/show.state';
import { map, Observable } from 'rxjs';
import { TranslocoModule } from '@ngneat/transloco';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { resizedToWidth } from '@plys/src/utils/media.utils';
import { pegiCodes } from '@plys/src/models/show';
import { getDayName, getTimeRange } from '../show-time.utils';

/**
 * `.movie-card-image-container` caps the poster at 110px only below `md`; from `md` up it is
 * `width: 40%` with `max-width: none`, which reaches roughly 190px on a wide desktop. Sized for that
 * end of the range, since a poster asked for at 110 is what renders soft there.
 */
const POSTER_BOX_WIDTH = 190;

export interface ShowViewData {
  title: string;
  image: string;
  cinema: string;
  room: string;
  time: string;
  day: string;
  pegiCodes: string[];
}

@Component({
  selector: 'plys-movie-widget',
  standalone: true,
  imports: [CommonModule, TranslocoModule, InlineSVGModule],
  templateUrl: './movie-widget.component.html',
  styleUrls: ['./movie-widget.component.scss'],
})
export class MovieWidgetComponent {
  @Input() size = 'md';

  show$: Observable<ShowViewData> = this.showState.show$.pipe(
    map((data) => {
      if (!data) {
        return null;
      }

      return {
        title: data.title,
        image: resizedToWidth(data.photo.url, POSTER_BOX_WIDTH),
        cinema: `${data.cinemaName}`,
        room: data.areaName,
        time: getTimeRange(data.startTime, data.endTime),
        day: getDayName(data.startTime),
        pegiCodes: pegiCodes(data.pegis),
      };
    })
  );

  constructor(private showState: ShowState) {}
}
